function pad(n) {
  return String(n).padStart(2, '0');
}

function addBusinessDays(date, days, skipWeekends) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay(); // 0 = Sun, 6 = Sat
    if (skipWeekends && (day === 0 || day === 6)) continue;
    added++;
  }
  return result;
}

function formatDate(date) {
  return date.toLocaleDateString(document.documentElement.lang || 'en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

function updateEstimate(el) {
  const cutoffHour = parseInt(el.dataset.cutoffHour, 10) || 17;
  const shipDays = parseInt(el.dataset.shipDays, 10) || 2;
  const skipWeekends = el.dataset.skipWeekends !== 'false';

  const countdownEl = el.querySelector('[data-shipping-countdown]');
  const dateEl = el.querySelector('[data-shipping-date]');

  function tick() {
    const now = new Date();
    const cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    let msLeft = cutoff - now;
    let baseDate = new Date(now);

    if (msLeft <= 0) {
      // past today's cutoff — count down to tomorrow's cutoff instead,
      // and push the delivery calculation to start from tomorrow
      cutoff.setDate(cutoff.getDate() + 1);
      msLeft = cutoff - now;
      baseDate.setDate(baseDate.getDate() + 1);
    }

    const totalMinutes = Math.floor(msLeft / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    countdownEl.textContent = `${pad(hours)}h ${pad(minutes)}m`;

    const deliveryDate = addBusinessDays(baseDate, shipDays, skipWeekends);
    dateEl.textContent = formatDate(deliveryDate) + '.';
  }

  tick();
  return setInterval(tick, 60000); // update every minute
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-shipping-estimate]').forEach(updateEstimate);
});